export default "/Frontend/dist/xls-black.c93291b0f4854eeb973a8594fa88f43d.svg";